// LocalStorage Manager

const MANAGER_TOKEN_KEY = 'managerToken';
const MANAGER_ID_KEY = 'managerID';
const MANAGEMENT_DATA_KEY = 'managementData';
const LANGUAGE_PREFERENCE_KEY = 'languagePreference';
const MANAGER_NAME_KEY = 'managerName';
const MANAGER_AUTHORIZATION_KEY = 'managerAuthorization';
const FEEDBACK_STATS_COLLAPSED_KEY = 'feedbackStatsCollapsed';
const EDM_TEST_SEND_HISTORY_KEY = 'edmTestSendHistory';

// Helper for getting JSON items
const getItemJSON = (key) => {
    const item = localStorage.getItem(key);
    try {
        return item ? JSON.parse(item) : null;
    } catch (e) {
        console.error(`Error parsing JSON from localStorage key "${key}":`, e);
        return null;
    }
};

// Helper for setting JSON items
const setItemJSON = (key, value) => {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
        console.error(`Error stringifying JSON for localStorage key "${key}":`, e);
    }
};

export const getManagerToken = () => localStorage.getItem(MANAGER_TOKEN_KEY);
export const setManagerToken = (token) => localStorage.setItem(MANAGER_TOKEN_KEY, token);
export const removeManagerToken = () => localStorage.removeItem(MANAGER_TOKEN_KEY);

export const getManagerID = () => localStorage.getItem(MANAGER_ID_KEY);
export const setManagerID = (id) => localStorage.setItem(MANAGER_ID_KEY, id);
export const removeManagerID = () => localStorage.removeItem(MANAGER_ID_KEY);

export const getManagerName = () => localStorage.getItem(MANAGER_NAME_KEY);
export const setManagerName = (name) => localStorage.setItem(MANAGER_NAME_KEY, name);
export const removeManagerName = () => localStorage.removeItem(MANAGER_NAME_KEY);

export const getManagerAuthorization = () => localStorage.getItem(MANAGER_AUTHORIZATION_KEY);
export const setManagerAuthorization = (authorization) => localStorage.setItem(MANAGER_AUTHORIZATION_KEY, authorization);
export const removeManagerAuthorization = () => localStorage.removeItem(MANAGER_AUTHORIZATION_KEY);

export const getManagementData = () => getItemJSON(MANAGEMENT_DATA_KEY);
export const setManagementData = (data) => setItemJSON(MANAGEMENT_DATA_KEY, data);
export const removeManagementData = () => localStorage.removeItem(MANAGEMENT_DATA_KEY);

export const getLanguagePreference = () => localStorage.getItem(LANGUAGE_PREFERENCE_KEY);
export const setLanguagePreference = (language) => localStorage.setItem(LANGUAGE_PREFERENCE_KEY, language);
export const removeLanguagePreference = () => localStorage.removeItem(LANGUAGE_PREFERENCE_KEY);

export const getFeedbackStatsCollapsed = () => {
    const state = localStorage.getItem(FEEDBACK_STATS_COLLAPSED_KEY);
    return state === 'true';
};

export const setFeedbackStatsCollapsed = (isCollapsed) => {
    localStorage.setItem(FEEDBACK_STATS_COLLAPSED_KEY, isCollapsed.toString());
};

export const clearAuthData = () => {
    removeManagerToken();
    removeManagerID();
    removeManagerName();
    removeManagerAuthorization();
};

export const clearAllManagedData = () => {
    clearAuthData();
    removeManagementData();
    removeLanguagePreference();
    localStorage.removeItem(FEEDBACK_STATS_COLLAPSED_KEY);
    localStorage.removeItem(EDM_TEST_SEND_HISTORY_KEY);
    // Add any other app-specific data keys here if needed in the future
};

// EDM Test Send History Management
export const getEDMTestSendHistory = () => getItemJSON(EDM_TEST_SEND_HISTORY_KEY) || [];
export const setEDMTestSendHistory = (history) => setItemJSON(EDM_TEST_SEND_HISTORY_KEY, history);
export const removeEDMTestSendHistory = () => localStorage.removeItem(EDM_TEST_SEND_HISTORY_KEY);